import axios from "axios";

const IWORequestService = axios.create({
  baseURL: "http://localhost:51976/attme/",
  // baseURL: "https://esystems.cdl.lk/backend/AttendMe2/attme/",
  // baseURL: "https://esystems.cdl.lk/backend-test/AttendMe2/attme/",
  headers: {
    "Content-Type": "application/json",
    UserId: "DTSUSER",
    Password: "Dts@10099",
  },
});

IWORequestService.interceptors.request.use((config) => {
  const employeeId = localStorage.getItem("employeeId");
  if (employeeId) {
    config.headers.loggedUser = employeeId;
  }
  return config;
});

export const getCDLEngList = () =>
  IWORequestService.get("EmployeeDetails/GetCDLEngList");

export const getCDLSupList = () =>
  IWORequestService.get("EmployeeDetails/GetCDLSupList");

export default IWORequestService;